import React from 'react';
import { ContentContainer } from '@flow/components/ui';
import ImageCarousel from '@flow/components/carousel/ImageCarousel';

export const renderContent = (content_group: any) => {
  if (content_group) {
    const {
      content,
    } = content_group;

    return (<ContentContainer dangerouslySetInnerHTML={{ __html: content }}/>);
  } else {
    return null;
  }
};

export const renderImageCarousel = (images: any) => {
  if (images) {
    return (<ImageCarousel images={images}/>);
  } else {
    return null;
  }
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/default/ui/index.tsx